module.exports = __webpack_public_path__ + "static/8-3d41ccb0da5805c4f925c3aa5838d8c3.jpg";